// extracted by mini-css-extract-plugin
export default {"homePageWrapper":"HomeWrapper_homePageWrapper__AcMmZ"};